(() => {
  const SWATCH_SELECTOR =
    '.js-color-swatches-wrapper .js-color-swatches input';
  const proxy = (root = document) => {
    const assets = window.themeAssets;
    if (!assets) {
      return Promise.reject(
        new Error('El cargador de assets del tema no está disponible.'),
      );
    }

    return assets.loadProductCard().then(() => {
      const initializer = window.colorSwatches;
      if (typeof initializer === 'function' && initializer !== proxy) {
        initializer(root);
      }
      return initializer;
    });
  };

  const containsSwatches = (root = document) =>
    Boolean(
      root.matches?.(SWATCH_SELECTOR) || root.querySelector?.(SWATCH_SELECTOR),
    );

  const initialize = (root = document) => {
    if (!containsSwatches(root)) return Promise.resolve(false);

    return proxy(root)
      .then(() => true)
      .catch((error) => {
        console.error('No fue posible cargar los swatches de producto.', error);
        return false;
      });
  };

  if (typeof window.colorSwatches !== 'function') {
    window.colorSwatches = proxy;
  }
  window.loadProductCards = initialize;

  const start = () => {
    initialize(document);

    if (typeof MutationObserver === 'function') {
      const observer = new MutationObserver((mutations) => {
        for (const mutation of mutations) {
          for (const node of mutation.addedNodes) {
            if (node.nodeType !== Node.ELEMENT_NODE) continue;
            if (containsSwatches(node)) {
              initialize(node);
              return;
            }
          }
        }
      });
      observer.observe(document.documentElement, { childList: true, subtree: true });
    }

    document.addEventListener('shopify:section:load', (event) => {
      initialize(event.target);
    });
    document.addEventListener('theme:pagination:loaded', (event) => {
      initialize(event.detail?.root || document);
    });
  };

  if (window.themeAssets) start();
  else window.addEventListener('theme:assets:ready', start, { once: true });
})();
